import React from 'react';
export const PanelPickerContext = /*#__PURE__*/React.createContext({});
export const PanelPresetsContext = /*#__PURE__*/React.createContext({});
export const {
  Provider: PanelPickerProvider
} = PanelPickerContext;
export const {
  Provider: PanelPresetsProvider
} = PanelPresetsContext;